import React from 'react'
import { useTranslation } from 'react-i18next';

const Refunds = () => {
  const { t } = useTranslation();

  return (
    <div>
  <main className="page-content">
    <div className="tm-about-area tm-padding-section bg-white">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="tm-about-content">
              <h4>{t("RR1")}</h4>
              <h6>{t("RR2")}</h6>
              <h6>{t("RR3")}</h6>
              <p>{t("RR4")}
              </p>
              <p>{t("RR5")}</p>
              <p>{t("RR6")}</p>
              <h6>{t("RR7")}</h6>
              <p>{t("RR8")}</p>
              <p>{t("RR9")}</p>
              <h6>{t("RR10")}</h6>
              <p>{t("RR11")}</p>
              <h6>{t("RR12")}</h6>
              <p>{t("RR13")}</p>
              <h6>{t("RR14")}</h6>
              <p>{t("RR15")}</p>
              <h6>{t("RR16")}</h6>
              {/* <p>{t("RR17")}</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

  )
}

export default Refunds
